export default {
  'AF': 'Afrique',
  'AN': 'Antartique',
  'AS': 'Asie',
  'EU': 'Europe',
  'NA': 'Amérique du Nord',
  'OC': 'Océanie',
  'SA': 'Amérique du Sud',
  'XX': 'Autre'
}



// WEBPACK FOOTER //
// ./src/lang/continents/fr.js